"use client";

/**
 * NewForm DS hover icon — a thumbs-down for negative feedback.
 * Mirrors ThumbsUpIcon: on hover the hand drops and rocks forward.
 * See ./hoverIcon for the colour/animation conventions.
 */

import { type HoverIconProps, HoverIconSvg } from "./hoverIcon";

export function ThumbsDownIcon({ size, className }: HoverIconProps) {
  return (
    <HoverIconSvg size={size} className={className}>
      <g className="g a-thumbdown" style={{ transformOrigin: "70% 10%" }}>
        <path d="M17 13.6V2.4" />
        <path d="M9.1 18.1 10 14H4.4a2 2 0 0 1-1.9-2.6l2.3-7.6a2 2 0 0 1 1.9-1.4H20a1.8 1.8 0 0 1 1.8 1.8v7.6A1.8 1.8 0 0 1 20 13.6h-2.7a2 2 0 0 0-1.8 1.1l-3.4 6.9a3 3 0 0 1-3-3.5Z" />
      </g>
    </HoverIconSvg>
  );
}
